export default function NavbarBottom() {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <footer className="footer">
        <div className="container-fluid d-flex justify-content-center">
          <div className="copyright">
            {currentYear}, feito por{" "}
            <i className="fa fa-heart heart text-danger"></i>
            <a href="http://www.code2business.com/" target="_blank">
              Code2Business
            </a>{" "}
            Ltda.
          </div>
        </div>
      </footer>
    </>
  );
}
